import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { tID } from '../../utils/utils'

export type ToDoChecklistIconProps = {
  size?: number | string
  fillColor?: string
}

export const ToDoChecklistIcon: FunctionComponent<ToDoChecklistIconProps> = ({ size = 24, fillColor }) => {
  const { colors } = useTheme()
  const fill = fillColor || colors.iconDefault

  return (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' testID={tID('ToDoChecklistIcon')}>
      <Path
        d='M19.3135 20.0635V21.5635H4.6875V20.0635H19.3135ZM20.0635 19.3135V4.6875C20.0635 4.27343 19.7275 3.93773 19.3135 3.9375H4.6875C4.27329 3.9375 3.9375 4.27329 3.9375 4.6875V19.3135C3.93776 19.7275 4.27344 20.0635 4.6875 20.0635V21.5635L4.45703 21.5518C3.39825 21.4441 2.55672 20.6018 2.44922 19.543L2.4375 19.3135V4.6875C2.4375 3.44486 3.44486 2.4375 4.6875 2.4375H19.3135L19.543 2.44922C20.6776 2.56439 21.5635 3.52248 21.5635 4.6875V19.3135L21.5518 19.543C21.4443 20.602 20.602 21.4443 19.543 21.5518L19.3135 21.5635V20.0635C19.7273 20.0632 20.0632 19.7273 20.0635 19.3135Z'
        fill={fill}
      />
      <Path
        d='M14.7789 6.30579C15.1931 6.30585 15.5289 6.64161 15.5289 7.05579C15.5289 7.46996 15.1931 7.80572 14.7789 7.80579H6.43616C6.02194 7.80579 5.68616 7.47 5.68616 7.05579C5.68616 6.64157 6.02194 6.30579 6.43616 6.30579H14.7789Z'
        fill={fill}
      />
      <Path
        d='M14.7789 9.66C15.1931 9.66007 15.5289 9.99583 15.5289 10.41C15.5289 10.8242 15.1931 11.1599 14.7789 11.16H6.43616C6.02194 11.16 5.68616 10.8242 5.68616 10.41C5.68616 9.99579 6.02194 9.66 6.43616 9.66H14.7789Z'
        fill={fill}
      />
      <Path
        d='M10.6071 13.0144C11.0213 13.0144 11.3571 13.3502 11.3571 13.7644C11.3571 14.1786 11.0213 14.5144 10.6071 14.5144H6.43616C6.02194 14.5144 5.68616 14.1786 5.68616 13.7644C5.68616 13.3502 6.02194 13.0144 6.43616 13.0144H10.6071Z'
        fill={fill}
      />
      <Path
        d='M17.4944 13.4111C17.708 13.0564 18.1689 12.9419 18.5237 13.1552C18.8785 13.3689 18.9932 13.8297 18.7796 14.1845L16.0501 18.7187C15.926 18.9246 15.7105 19.0586 15.471 19.0791C15.2314 19.0994 14.9962 19.0034 14.8391 18.8213L13.1546 16.8672C12.8844 16.5534 12.9201 16.0799 13.2337 15.8095C13.5474 15.5394 14.0209 15.5741 14.2913 15.8877L15.2981 17.0566L17.4944 13.4111Z'
        fill={fill}
      />
    </Svg>
  )
}
